import React, { useEffect, useState } from "react";
import {
  getDoc,
  query,
  documentId,
  where,
  collection,
  getDocs
} from "firebase/firestore";
import { db } from "../../../firebase";
import { Table } from "react-bootstrap";
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  InputGroup,
  FormInput,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalBody,
  ModalHeader
} from "shards-react";
import "./tab.css";
import Charts from "./Chart";
import moment from "moment";
import axios from "axios";
import {
  convertTomm,
  roundOffTwo,
  roundOff
} from "../../../utils/common_handlers";
import { Cloud_API_URL } from "../../../utils/constants";

const Calibration = ({ userdata }) => {
  // const latestCalibrationId = userdata.CalibrateResult && userdata.CalibrateResult.id;
  const prevCalibrationIds = userdata.PrevCalibrationResult
    ? userdata.PrevCalibrationResult
    : [];
  let calibId = [];
  if (userdata.CalibrateResult) {
    calibId.push(userdata.CalibrateResult.id);
  }
  if (prevCalibrationIds.length > 0) {
    for (let index = 0; index < prevCalibrationIds.length; index++) {
      calibId.push(prevCalibrationIds[index].id);
    }
  }

  const [prevCalibrations, setPrevCalibrations] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);
  const [sorted, setSorted] = useState(false);
  const [search_text, setSearch_text] = useState("");
  const [overViewModal, setOverViewModal] = useState(false);
  const [overViewModalSQL, setOverViewModalSQL] = useState(false);
  const [calibrationData, setCalibrationData] = useState(null);

  // State for SQL API data
  const [sqlCalibrations, setSqlCalibrations] = useState([]);
  const [sqlDataLoading, setSqlDataLoading] = useState(false);
  //const [calibOverViewId, setCalibOverViewId] = useState("");

  useEffect(() => {
    getPrevCalibrations();
    fetchSqlCalibrations(userdata.uuid);
  }, []);

  const getPrevCalibrations = async () => {
    const docRef = collection(db, "CalibrateResult");
    let calibData = [];
    let ids = [];
    setDataLoading(true);
    for (let cc = 0; cc < calibId.length; cc++) {
      if (ids.length < 10) {
        ids.push(calibId[cc]);
      }
      if (ids.length === 10 || cc === calibId.length - 1) {
        const docSnap = query(docRef, where(documentId(), "in", ids));
        const ddd = await getDocs(docSnap);
        for (const cdata of ddd.docs) {
          let avg = !isNotExists(cdata.data().RecordedDevice)
            ? cdata.data().CalibrationAvg
            : convertTomm(cdata.data().CalibrationAvg);
          let calibration5Data = cdata.data().CalibrationData;
          let RecordedDeviceData = null;
          if (cdata.data().RecordedDevice) {
            const deviceData = await getDoc(cdata.data().RecordedDevice);
            if (deviceData.exists()) {
              RecordedDeviceData = deviceData.data();
            }
          }
          if (!isNotExists(cdata.data().RecordedDevice)) {
            let c5Data = [];
            calibration5Data.forEach(item => {
              c5Data.push(roundOffTwo(item));
            });
            calibration5Data = c5Data;
          }
          calibData.push({
            uid: cdata.id,
            ...cdata.data(),
            CalibrationAvg: avg,
            CalibrationData: calibration5Data,
            RecordedDeviceData
          });
        }
        ids = [];
      }
    }
    const sortedCalibData = calibData.sort(
      (a, b) =>
        new Date(b.CalibratedOnDate.toDate()) -
        new Date(a.CalibratedOnDate.toDate())
    );

    setPrevCalibrations(sortedCalibData);
    setDataLoading(false);
  };

  const fetchSqlCalibrations = async userId => {
    setSqlDataLoading(true);
    try {
      const response = await axios.get(
        `${Cloud_API_URL}/user/${userId}/calibration_data`
      );
      console.log("resp:", response);
      const sortedData = response.data.sort(
        (a, b) => new Date(b.calibration_date) - new Date(a.calibration_date)
      );
      setSqlCalibrations(sortedData);
    } catch (error) {
      console.error("Error fetching SQL calibration data:", error);
    }
    setSqlDataLoading(false);
  };

  const toggleOverViewModal = () => {
    setOverViewModal(!overViewModal);
  };
  const toggleOverViewModalSQL = () => {
    setOverViewModalSQL(!overViewModalSQL);
  };

  const viewCalibration = item => {
    setCalibrationData(item);
    // setCalibOverViewId(item.uid);
    setOverViewModal(true);
    if (!sorted) {
      const sortedCalibrations = prevCalibrations.sort(
        (a, b) =>
          new Date(b.CalibratedOnDate.toDate()) -
          new Date(a.CalibratedOnDate.toDate())
      );

      setPrevCalibrations(sortedCalibrations);
      setSorted(true);
    }
    // if (userRole == 'sub-admin') {
    //   history.push(`/student-calibration-overview/${item.uid}`);
    // } else {
    //   history.push(`/calibration-overview/${item.uid}`);
    // }
  };

  const Search = async e => {
    setSearch_text(e.target.value);
  };
  const formatFirebaseData = data => {
    return data.map(item => ({
      CalibratedOnDate: item.CalibratedOnDate.toDate(),
      CalibrationAvg: item.CalibrationAvg
    }));
  };
  const formatSqlData = data => {
    return data.map(item => ({
      CalibratedOnDate: new Date(item.calibration_date),
      CalibrationAvg:
        item.calibration_data.reduce(
          (sum, calibration) => sum + parseFloat(calibration.value),
          0
        ) / item.calibration_data.length
    }));
  };

  const phoneResolution = data => {
    return `${data.width * data.pixelDensity} x ${data.height *
      data.pixelDensity}`;
  };
  function phoneResolutionSQL(width, height, pixelDensity) {
    return `${width * pixelDensity} x ${height * pixelDensity}`;
  }

  const isNotExists = value => [null, undefined].includes(value);
  const viewSQLCalibration = item => {
    console.log(item);
    setCalibrationData(item);
    setOverViewModalSQL(true);
    // If you want to sort sqlCalibrations, you can do it here
    // e.g. setSqlCalibrations([...sqlCalibrations].sort(...))
  };
  const renderTable = (calibrations, title, onRowClick) => (
    <Card small className="mb-4">
      <CardHeader className="border-bottom">
        <h6 className="m-0">{title}</h6>
        <div className="w-60 mt-2">
          <FormGroup>
            <InputGroup>
              <FormInput
                placeholder="Search"
                value={search_text}
                onChange={e => Search(e)}
              />
            </InputGroup>
          </FormGroup>
        </div>
      </CardHeader>
      <CardBody className="p-0 pb-3">
        <Table responsive="sm" bordered hover size="md">
          <thead className="bg-light">
            <tr>
              <th>Calibration Data</th>
              <th>Calibrated On Date</th>
              <th>Calibration Avg</th>
            </tr>
          </thead>
          <tbody>
            {calibrations
              .filter(item => {
                if (search_text === "") return true;
                // Match against whichever date fields exist
                const dateFirebase = item.CalibratedOnDate
                  ? item.CalibratedOnDate.toString()
                  : "";
                const dateSql = item.calibration_date
                  ? item.calibration_date.toString()
                  : "";
                return (
                  dateFirebase.includes(search_text) ||
                  dateSql.includes(search_text)
                );
              })
              .map((item, index) => {
                // Parse calibration data
                let calibrationData;
                if (Array.isArray(item.calibration_data)) {
                  calibrationData = item.calibration_data.map(data =>
                    parseFloat(data.value).toFixed(2)
                  );
                } else if (Array.isArray(item.CalibrationData)) {
                  calibrationData = item.CalibrationData.map(data =>
                    parseFloat(data).toFixed(2)
                  );
                } else {
                  calibrationData = [];
                }

                const formattedCalibrationData = `[${calibrationData.join(
                  ", "
                )}]`;

                // Calculate the average of calibrationData array
                const average =
                  calibrationData.length > 0
                    ? calibrationData.reduce(
                        (sum, val) => sum + parseFloat(val),
                        0
                      ) / calibrationData.length
                    : null;

                const avgToDisplay =
                  average !== null
                    ? average
                    : item.CalibrationAvg !== undefined
                    ? item.CalibrationAvg
                    : item.calibration_avg;

                return (
                  <tr key={index} onClick={() => onRowClick(item)}>
                    <td>{formattedCalibrationData}</td>
                    <td>
                      {item.CalibratedOnDate
                        ? moment(item.CalibratedOnDate.toDate()).format("lll")
                        : item.calibration_date
                        ? moment(item.calibration_date).format("lll")
                        : "N/A"}
                    </td>
                    <td>{roundOff(avgToDisplay || 0)}</td>
                  </tr>
                );
              })}
          </tbody>
        </Table>
      </CardBody>
    </Card>
  );

  return (
    <Container fluid className="main-content-container px-4 pb-4">
      <h4 className="mb-4">{`${userdata.FirstName} ${userdata.LastName}`}</h4>
      {prevCalibrations && prevCalibrations.length > 0 && (
        <Charts
          calibrationData={formatFirebaseData(prevCalibrations.reverse())}
        />
      )}

      <h4 className="mb-4">SQL</h4>
      {sqlCalibrations && sqlCalibrations.length > 0 ? (
        <div>
          <Charts calibrationData={formatSqlData(sqlCalibrations)} />
        </div>
      ) : (
        <div>No SQL Calibration Data Available</div>
      )}

      <Row className="d-flex align-items-stretch">
        <Col md="6" className="d-flex flex-column">
          <h5>Firebase Calibration Data</h5>
          {dataLoading ? (
            <div>Loading...</div>
          ) : (
            renderTable(prevCalibrations, "Firebase Data", viewCalibration)
          )}
        </Col>
        <Col md="6" className="d-flex flex-column">
          <h5>SQL API Calibration Data</h5>
          {sqlDataLoading ? (
            <div>Loading...</div>
          ) : (
            renderTable(sqlCalibrations, "SQL API Data", viewSQLCalibration)
          )}
        </Col>
      </Row>

      {/* -------------------
          Firebase Modal
      ---------------------*/}
      <Modal open={overViewModal} toggle={toggleOverViewModal}>
        <ModalHeader>Calibration Overview:</ModalHeader>
        <ModalBody>
          <ListGroup flush>
            <ListGroupItem>
              <strong>Calibrated On Date: </strong>
              {calibrationData &&
                (calibrationData.CalibratedOnDate
                  ? moment(calibrationData.CalibratedOnDate.toDate()).format(
                      "lll"
                    )
                  : calibrationData.calibration_date
                  ? moment(calibrationData.calibration_date).format("lll")
                  : "N/A")}
            </ListGroupItem>
            <ListGroupItem>
              <strong>Calibration Avg: </strong>
              {calibrationData &&
                (calibrationData.CalibrationAvg
                  ? roundOff(calibrationData.CalibrationAvg)
                  : roundOff(calibrationData.calibration_avg))}
            </ListGroupItem>
            <ListGroupItem>
              <strong>Offset Value: </strong>
              {calibrationData &&
              calibrationData.RecordedDeviceData &&
              calibrationData.RecordedDeviceData.deviceOffset
                ? calibrationData.RecordedDeviceData.deviceOffset
                : "-"}
            </ListGroupItem>
            <ListGroupItem>
              <strong>Pendulum Length: </strong>
              {calibrationData &&
                calibrationData.PendlumLength &&
                calibrationData.PendlumLength}
            </ListGroupItem>
            <ListGroupItem>
              <strong>Phone Resolutions: </strong>
              {calibrationData &&
              calibrationData.RecordedDeviceData &&
              calibrationData.RecordedDeviceData.dimensions
                ? phoneResolution(calibrationData.RecordedDeviceData.dimensions)
                : "-"}
            </ListGroupItem>
            <ListGroupItem>
              <strong>Device Model: </strong>
              {calibrationData &&
              calibrationData.RecordedDeviceData &&
              calibrationData.RecordedDeviceData.model
                ? calibrationData.RecordedDeviceData.model
                : "-"}
            </ListGroupItem>
          </ListGroup>
        </ModalBody>
      </Modal>

      {/* -------------------
          SQL Modal
      ---------------------*/}
      <Modal open={overViewModalSQL} toggle={toggleOverViewModalSQL}>
        <ModalHeader>Calibration Overview:</ModalHeader>
        <ModalBody>
          <ListGroup flush>
            <ListGroupItem>
              {console.log(sqlCalibrations)}
              <strong>Calibrated On Date: </strong>
              {calibrationData &&
                (calibrationData.CalibratedOnDate
                  ? moment(calibrationData.CalibratedOnDate.toDate()).format(
                      "lll"
                    )
                  : calibrationData.calibration_date
                  ? moment(calibrationData.calibration_date).format("lll")
                  : "N/A")}
            </ListGroupItem>
            <ListGroupItem>
              <strong>Calibration Avg: </strong>
              {calibrationData &&
              calibrationData.calibration_data &&
              calibrationData.calibration_data.length > 0
                ? // Calculate the average
                  roundOff(
                    calibrationData.calibration_data.reduce((sum, dataItem) => {
                      return sum + parseFloat(dataItem.value);
                    }, 0) / calibrationData.calibration_data.length
                  )
                : "N/A"}
            </ListGroupItem>

            <ListGroupItem>
              <strong>Offset Value: </strong>
              {calibrationData &&
              calibrationData.RecordedDeviceData &&
              calibrationData.RecordedDeviceData.deviceOffset
                ? calibrationData.RecordedDeviceData.deviceOffset
                : "-"}
            </ListGroupItem>
            <ListGroupItem>
              <strong>Pendulum Length: </strong>
              {calibrationData && calibrationData.PendlumLength
                ? calibrationData.PendlumLength
                : "-"}
            </ListGroupItem>
            <ListGroupItem>
              <strong>Phone Resolutions: </strong>
              {calibrationData &&
              calibrationData.RecordedDeviceData &&
              calibrationData.RecordedDeviceData.width &&
              calibrationData.RecordedDeviceData.height
                ? phoneResolutionSQL(
                    calibrationData.RecordedDeviceData.width,
                    calibrationData.RecordedDeviceData.height,
                    calibrationData.RecordedDeviceData.pixelDensity
                  )
                : "-"}
            </ListGroupItem>
            <ListGroupItem>
              <strong>Device Model: </strong>
              {calibrationData &&
              calibrationData.RecordedDeviceData &&
              calibrationData.RecordedDeviceData.model
                ? calibrationData.RecordedDeviceData.model
                : "-"}
            </ListGroupItem>
          </ListGroup>
        </ModalBody>
      </Modal>
    </Container>
  );
};

export default Calibration;
